import React, { memo } from "react";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import "react-leaflet-fullscreen/dist";
import "react-leaflet-fullscreen/dist/styles.css";
import MapCache from "../../../../components/MapCache";
import "./style.scss";

const OperationMap = memo(({ featureCollection, ...props }) => {
  const features = featureCollection.features.map(feature => feature);
  const onlyXY = features
    .map(feature => {
      return feature.geometry.coordinates[0].map(coord => {
        return coord.filter((_, index) => index !== 2);
      });
    })
    .flat(1);

  const bounds = onlyXY.map(coord => [...coord].reverse());

  return (
    <>
      <MapContainer
        fullscreenControl
        center={onlyXY[0]}
        zoom={15}
        bounds={bounds}
        maxBounds={bounds}
        {...props}
      >
        <TileLayer
          // attribution='&amp;copy <a href="https://www.openstreetmap.org/about">OpenStreetMap</a>'
          // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          url="http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"
          minZoom="10"
          subdomains={["mt0", "mt1", "mt2", "mt3"]}
        />

        <MapCache />

        {features.map((feature, index) => (
          <GeoJSON key={`${index}`} data={feature.geometry} color="#13FFE8" />
        ))}
      </MapContainer>
    </>
  );
});

export default OperationMap;
